import { render, staticRenderFns } from "./SideNavbar.vue?vue&type=template&id=438d20a3&scoped=true"
import script from "./SideNavbar.vue?vue&type=script&lang=js"
export * from "./SideNavbar.vue?vue&type=script&lang=js"
import style0 from "./SideNavbar.vue?vue&type=style&index=0&id=438d20a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d20a3",
  null
  
)

export default component.exports